import { notification as AntNotification } from '@vertem-core/vertice-ds';

const notification = AntNotification;

export default notification;
